import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Question = forwardRef<SVGSVGElement, SvgIconProps>(
  function Question(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M6.5 8.24c0-5.28 9.9-5.62 9.9-.17 0 3.24-3.24 3.07-3.93 6.14-.34 1.53-2.38 1.36-2.38-.34 0-2.9 2.38-3.07 3.4-4.95.69-1.36-.5-2.72-1.87-2.72-2.9 0-1.87 3.23-3.75 3.23-.68 0-1.36-.5-1.36-1.19zm4.78 10.91c-2.05 0-1.88-3.07 0-3.07 2.05 0 2.05 3.07 0 3.07z" />
      </SvgIcon>
    )
  },
)

export default Question
